<template>
  <div class="my-2">
    <v-alert
      dense
      outlined
      close-icon="mdi-close-circle"
      v-show="showAlert"
      type="error"
    >
      <p>{{ $t("errorOccurred") }}</p>
      <div class="d-flex" v-for="(item, i) in alertContent" :key="i">
        {{ item }}
      </div>
    </v-alert>
    <div
      class="dropZone"
      @dragenter="dragging = true"
      @dragleave="dragging = false"
      @drag="onChange"
    >
      <div class="dropZone-info" v-if="!isFilesWasDropped">
        <v-icon class="mx-2" light>mdi-cloud-upload-outline</v-icon>
        <span class="dropZone-title">{{ $t("uploadText") }}</span>
      </div>
      <input
        type="file"
        ref="inputRef"
        @change="onChange"
        :disabled="disabled"
        :accept="contentMediaType"
        :multiple="multipleFlag"
      />
      <div v-if="isFilesWasDropped">
        <v-row dense v-for="(item, i) in localFiles" :key="i" class="my-1">
          <v-col cols="" class="d-flex align-center">
            <v-icon
              v-if="!disabled"
              size="20"
              class="mx-1"
              @click="deleteFile(item)"
              style="cursor: pointer"
              light
              >mdi-close
            </v-icon>

            <span
              class="mr-2 secondary--text link"
              :class="{ 'link-active': downloadable }"
              @click.stop="downloadable ? downloadFile(item) : null"
            >
              {{ item.name }}
            </span>

            <v-progress-linear
              v-if="!item.uploadFlag"
              class="mx-2"
              color="blue-grey"
              indeterminate
              rounded
              height="6"
              style="width: 40px"
            ></v-progress-linear>

            {{ item.alertIcon }}
            <v-icon
              v-if="item.uploadFlag && item.alertIcon !== undefined"
              size="22"
              color="error"
              >{{ item.alertIcon }}
            </v-icon>
          </v-col>
          <v-col
            v-if="i === 0 && localFiles.length > 1 && !disabled"
            cols="auto"
            align="right"
          >
            <v-chip
              @click="deleteAllFiles"
              small
              color="grey lighten-1"
              class="mr-1"
              light
            >
              {{ $t("deleteAllFilesLabel") }}
              <v-icon class="ml-1" small>mdi-close-circle</v-icon>
            </v-chip>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TcnDropZone",
  components: {},
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: { type: Array, required: true },
    alertContent: { type: Array, required: true },
    multiple: { type: Boolean, required: false, default: true },
    downloadable: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    maxFiles: { type: Number, required: false, default: 5 },
    fileMaxSize: { type: Number, required: false, default: 2 },
    mediaType: { type: String, required: false, default: "*/*" },
  },
  data() {
    return {
      dragging: false,
    };
  },
  computed: {
    localFiles: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    multipleFlag() {
      return this.multiple;
    },

    fileLimit() {
      if (!this.multipleFlag) {
        return 1;
      } else {
        return this.maxFiles;
      }
    },

    contentMediaType() {
      return this.mediaType;
    },

    fileSizeLimitInMB() {
      return this.fileMaxSize;
    },

    showAlert() {
      return this.alertContent.length > 0;
    },

    isFilesWasDropped() {
      return this.localFiles.length > 0;
    },
  },
  watch: {},

  methods: {
    async onChange(e) {
      let incomingFiles = Array.from(e.target.files || e.dataTransfer.files);

      incomingFiles.forEach((file) => {
        if (this.localFiles.some((item) => item.name === file.name)) {
          let fileCopyRegExp = this.filenameRegexp(file.name);
          let fileNameArray = this.localFiles.filter(
            (item) => item.name === file.name || fileCopyRegExp.test(item.name)
          );
          let splitName = file.name.split(".");
          file = renameFile(
            file,
            `${splitName[0]} (${fileNameArray.length}).${splitName[1]}`
          );
        }

        if (this.isValid(file)) {
          if (this.localFiles.length !== 0 && !this.multipleFlag) {
            // single file
            this.localFiles = [];
            this.resultArray = [];
          }
          this.localFiles.push(file);
          this.$emit("uploadFile", file);
        }
      });

      let dt = new DataTransfer();
      this.$refs.inputRef.files = dt.files;
    },

    isValid(file) {
      if (this.localFiles.length < this.fileLimit) {
        if (
          this.contentMediaType !== "*/*" &&
          !file.type.match(this.contentMediaType)
        ) {
          this.alertContent.push(
            this.$t("contentTypeMessage", { name: file.name })
          );
          return false;
        } else if (
          !(
            (file.size / (1024 * 1024)).toFixed(2) <=
            this.fileSizeLimitInMB.toFixed(2)
          )
        ) {
          this.alertContent.push(
            this.$t("sizeFileLimit", {
              name: file.name,
              size: this.fileSizeLimitInMB,
            })
          );
          return false;
        } else {
          return true;
        }
      } else {
        this.alertContent.push(
          this.$t("limitMessage", { name: file.name, limit: this.fileLimit })
        );
        return false;
      }
    },

    deleteAllFiles() {
      this.localFiles.forEach((item) => {
        this.deleteFile(item);
      });
      this.localFiles = [];
      this.resultArray = [];
      this.clearAlert();
    },

    deleteFile(file) {
      this.$emit("deleteFile", file);
    },
    downloadFile(file) {
      this.$emit("downloadFile", file);
    },

    clearAlert() {
      this.$emit("clearAlert");
    },

    filenameRegexp(filename) {
      let t = filename.split(".")[0];
      return new RegExp(`${t}[ ]\\([1-9]\\)`);
    },

    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
  },
  mounted() {},
};
</script>
<i18n lang="i18n">
{
  "pl": {
    "uploadText": "Dodaj lub upuść pliki aby wgrać",
    "deleteAllFilesLabel": "Usuń wszystkie pliki",
    "errorOccurred": "Wystąpił błąd",
    "limitMessage": "Plik o nazwie {name} nie został dodany - Przekroczono limit załączników (max. {limit} załączników.)",
    "contentTypeMessage": "Plik o nazwie {name} nie został dodany - Niezgodny typ pliku.",
    "dictionaryFetchError": "Wystąpił błąd podczas pobierania listy tagów ze słownika.",
    "sizeFileLimit": "Plik o nazwie {name} nie może być wgrany, przekroczono dozwolony rozmiar pliku: {size} MB.",
    "uploadError": "Nie udało się wgrać pliku o nazwie {name}."
  },
  "en": {
    "uploadText": "Drop file or click to upload",
    "deleteAllFilesLabel": "Delete all files",
    "errorOccurred": "Error occurred",
    "limitMessage": "File named {name} was not added - Attachment limit exceeded (max {limit} attachments).",
    "contentTypeMessage": "File named {name} was not added - Incompatible file type.",
    "dictionaryFetchError": "An error occurred while retrieving the tag list from the dictionary.",
    "sizeFileLimit": "File named {name} cannot be uploaded, the allowed file size has been exceeded: {size} MB.",
    "uploadError": "File named {name} cannot be uploaded"
  }
}
</i18n>

<style scoped lang="scss">
.dropZone {
  min-height: 140px;
  position: relative;
  border: 3px dashed gray;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 80%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
.link {
  z-index: 100;
  cursor: default;
}
.link-active:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
